var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPdfDownloadDocumentIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17,
    height: 18,
    viewBox: "0 0 23.764 22.348",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "prefix__files"
  }, /*#__PURE__*/React.createElement("g", {
    id: "prefix__Group_2456",
    "data-name": "Group 2456"
  }, /*#__PURE__*/React.createElement("g", {
    id: "prefix__Group_2455",
    "data-name": "Group 2455"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#12203c",
    id: "prefix__Path_606",
    d: "M1.4 20.252V2.095a.7.7 0 0 1 .7-.7h10.471V4.19a1.4 1.4 0 0 0 1.4 1.4h2.793v2.1h1.4V4.888a.7.7 0 0 0-.2-.5L13.765.2a.7.7 0 0 0-.5-.2H2.1A2.1 2.1 0 0 0 0 2.095v18.157a2.1 2.1 0 0 0 2.1 2.1h4.884v-1.4H2.1a.7.7 0 0 1-.7-.7z",
    "data-name": "Path 606"
  }), /*#__PURE__*/React.createElement("text", {
    fontSize: "8px",
    fontFamily: "ProximaNova-Bold,Proxima Nova",
    fontWeight: "700;fill:#12203c",
    id: "prefix__PDF",
    transform: "translate(7.764 15.414)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "PDF")))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPdfDownloadDocumentIcon);
export default __webpack_public_path__ + "static/media/PdfDownloadDocumentIcon.cbb35df3e7b6ad85565231aef07f7e9a.svg";
export { ForwardRef as ReactComponent };